import React from "react";
import {Button} from "../Button";
import {InteractivePopover} from "../Popover";

export interface InfoPopoverProps {
    content: React.ReactNode,
    direction: 'top' | 'bottom' | 'left' | 'right',
    label?: string,
    width?: string,
    arrow?: boolean,
    className?: string,
    size?: 'large' | 'medium' | 'small',
}

const InfoPopover = ({
                         content,
                         direction,
                         label = "info-popover",
                         width,
                         arrow=false,
                         className,
                         size="small"
                     }: InfoPopoverProps) => {
    return (
        <InteractivePopover
            arrow={arrow}
            aria-label={label}
            className={className ? className : "popover-text"}
            content={content}
            direction={direction}
            width={width}
        >
            <Button className="popover-button"
                    icon="only"
                    iconName="info_outline"
                    kind="borderless"
                    size={size}
            />
        </InteractivePopover>
    )
}

export default InfoPopover;